import React from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faTimes } from "@fortawesome/free-solid-svg-icons";
import "../../../molecules/BrandModal.css";

export const ValidateModal = ({ toggle, setToggle, onConfirm }) => {
  const close = () => setToggle(false);

  const handleConfirm = async () => {
    close();
    await onConfirm();
  };

  return (
    <Modal isOpen={toggle} toggle={close} className="brand-modal">
      <ModalHeader toggle={close}>Validate Request</ModalHeader>
      <ModalBody>
        <p className="brand-modal__desc">Are you sure you want to validate this request?</p>
        <div className="brand-modal__actions">
          <button type="button" className="brand-modal__btn brand-modal__btn--primary" onClick={handleConfirm}>
            <FontAwesomeIcon icon={faCheckCircle} /> Validate
          </button>
          <button type="button" className="brand-modal__btn brand-modal__btn--cancel" onClick={close}>
            <FontAwesomeIcon icon={faTimes} /> Close
          </button>
        </div>
      </ModalBody>
    </Modal>
  );
};
